module.exports = __webpack_public_path__ + "assets/img/title.5747826b.png";